import { render } from "./ChangelogPage.vue?vue&type=template&id=dbedba9a"
import script from "./ChangelogPage.vue?vue&type=script&lang=js"
export * from "./ChangelogPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__